import React, { useState, useEffect, useCallback } from "react";
import { io } from "socket.io-client";

const params = new URLSearchParams(window.location.search);
export const access_token = params.get('access_token'); 
export const adminId = params.get('adminId'); 

const url = process.env.REACT_APP_PLINKO_URL;
// const url = "http://localhost:3002";

export const socketConn = io(
  `${url}?access_token=${access_token}`,
  {
    transports: ["websocket", "polling"], // Try WebSocket first, fallback to polling
    reconnectionAttempts: 1, // Number of reconnection attempts
    reconnectionDelay: 1000, // Time between reconnection attempts (ms)
    timeout: 20000, // Connection timeout
    forceNew: true, // Force a new connection
    path: "/socket.io/", // Confirm this matches your server configuration
    auth: {
      access_token: access_token,
     
    },
  }
);

